export default __webpack_public_path__ + "static/media/6.dfe09f87.png";